import React from 'react';

/* Context */
import { VehicleOverviewContext } from 'js/context';

/* Utilities */
import { trans } from 'js/utilities';

export default class VehicleOverviewSorting extends React.Component {
    static contextType = VehicleOverviewContext;

    constructor(props) {
        super(props);

        this.updateSorting = () => { };
    }

    componentDidMount() {
        this.updateSorting = this.context.updateSorting;
    }

    render() {
        const { sorting = []} = this.props;

        return (
            <select
                className="custom-select"
                value={sorting.find((sort) => sort.active)?.key}
                onChange={(event) => {
                    event.persist();
                    this.updateSorting(null, (sorting) => sorting.map((sort) => ({
                        ...sort,
                        active: sort.key == event.target.value,
                    })));
                }}
            >
                {sorting.map((sort) => (
                    <option key={sort.key} value={sort.key}>{trans(`webstores_voertuigen_voorraad.sorting.${sort.key}`, {}, sort.name)}</option>
                ))}
            </select>
        );
    }
}
